// @flow
import React from 'react';

import { FormattedMessage } from 'react-intl';

import GuidelinesComponent from './guidelines/GuidelinesComponent';
import './Selection.scss';
import SelectionItemComponent from './SelectionItemComponent';

type Props = {
  config: { selectedLocale: string },
  headerDetails: Object,
  guidelinesDetails: Object,
  guidelinesCallback: Function,
  children: React.ChildrenArray<React.Element<typeof SelectionItemComponent>>,
};

const SelectionComponent = (props: Props): Element => {
  const items = React.Children.toArray(props.children);
  const shouldWrapEarly = items.length >= 5;

  const componentGrid = (
    <div className="selection-component__container">
      <div className="selection-component__inner-container">
        <div className="selection-component__grid">
          {items.map((item) => {
            const wrapearly = shouldWrapEarly
              ? 'selection-component__griditem--wrapearly'
              : 'selection-component__griditem--wrapnormal';
            return (
              <div className={`selection-component__griditem ${wrapearly}`} key={item.key}>
                {item}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );

  return (
    <div className="selection-component">
      <div className="selection-component__header">
        <h3 className="selection-component__title">
          <FormattedMessage {...props.headerDetails.title} />
        </h3>
        {props.headerDetails.subtitle && (
          <div className="selection-component__subtitle">
            <FormattedMessage {...props.headerDetails.subtitle} />
          </div>
        )}
      </div>

      {componentGrid}
      <GuidelinesComponent
        locale={props.config.selectedLocale}
        guidelinesDetails={props.guidelinesDetails}
        guidelinesCallback={props.guidelinesCallback}
      />
    </div>
  );
};

export default SelectionComponent;
